import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../Button'
import { ButtonTextSelectControl, useSelectContext } from '../../Select'
import { Skeleton } from '../../Skeleton'
import { getRequestProfileHeaderStatusSelectValue } from '../RequestProfileHeaderStatusSelect'

import * as styles from './RequestProfileHeaderStatusSelectButton.module.css'

function RequestProfileHeaderStatusSelectButton({
  className,
  isSkeleton,
  qaName,
  ref,
  refs,
  ...restProps
}) {
  const { t } = useTranslation()
  const selectContext = useSelectContext() || EMPTY_OBJECT

  const { blocked, disabled, value } = selectContext

  const isButtonDisabled = blocked || disabled
  const preparedValue = value
    ? getRequestProfileHeaderStatusSelectValue(value, t)
    : null

  const buttonStyle = {
    '--request-profile-header-status-select-bg':
      preparedValue?.backgroundColor || 'var(--color-bg-second)',
    '--request-profile-header-status-select-color':
      preparedValue?.textColor || 'var(--secondary-text-color)',
  }

  return isSkeleton ? (
    <Skeleton className={classNames(styles.skeleton, className)} />
  ) : (
    <ButtonTextSelectControl
      {...restProps}
      buttonProps={{
        Button: Button.Select,
        className: styles.button,
        disabled: isButtonDisabled,
        height: BUTTON_HEIGHT_40,
        qaName,
        style: buttonStyle,
        text: preparedValue?.label,
        textClassName: styles.text,
      }}
      className={className}
      ref={ref}
      refs={refs}
    />
  )
}

export default RequestProfileHeaderStatusSelectButton
